@if (comoUser()) {
  <div
    class="m-5 flex flex-col gap-5 rounded-lg border-4 border-solid p-5"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.color]="textColor | contentBuilderColor"
    [style.borderColor]="secondaryButtonBackgroundColor | contentBuilderColor"
  >
    <div class="mb-5">
      @if (heading || subheading) {
        <div class="flex flex-col gap-2">
          <div class="flex flex-row justify-between">
            <div>
              @if (heading) {
                <div class="font-accent text-4xl font-bold">
                  {{ heading | translate }}
                </div>
              }
              @if (subheading) {
                <div class="px-5 font-base text-xl">
                  {{ subheading }}
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (
      (displayPoints && pointsBalance() && pointsBalance() > 0) ||
      (displayCredits && creditBalance() && creditBalance() > 0)
    ) {
      <div class="flex flex-row items-center font-base text-sm text-neutral-600 lg:text-base">
        <i class="icon icon-coins mt-0.5 pr-1.5"></i>
        @if (displayPoints && pointsBalance() && pointsBalance() > 0) {
          <span
            [translate]="'como.amount-of-points'"
            [translateParams]="{ points: pointsBalance() / 100 }"
          ></span>
        }
        @if (
          displayPoints &&
          pointsBalance() &&
          pointsBalance() > 0 &&
          displayCredits &&
          creditBalance() &&
          creditBalance() > 0
        ) {
          <span class="px-1">—</span>
        }
        @if (displayCredits && creditBalance() && creditBalance() > 0) {
          <span>
            {{ 'como.credits-label' | translate }}
            <app-price-atom
              [amount]="creditBalance()"
              [format]="true"
              [bold]="false"
              size="SM"
            ></app-price-atom>
          </span>
        }
      </div>
    }
    <app-kiosk-horizontal-scroll
      [leftButtonTemplate]="leftButton"
      [rightButtonTemplate]="rightButton"
      [contentTemplate]="content"
      #horizontalScroll
    >
      <ng-template #leftButton>
        @let leftButtonData = horizontalScroll.leftButtonData;
        <app-button-atom
          size="S"
          color="neutral"
          [icon]="'icon-arrow-down-s'"
          [iconRotation]="'180'"
          type="kiosk-light"
          thickSize="S"
          [full]="false"
          [aspectSquare]="true"
          [disabled]="leftButtonData().disabled"
        ></app-button-atom>
      </ng-template>
      <ng-template #rightButton>
        @let rightButtonData = horizontalScroll.rightButtonData;
        <app-button-atom
          size="S"
          color="neutral"
          [icon]="'icon-arrow-down-s'"
          [iconRotation]="'270'"
          type="kiosk-light"
          thickSize="S"
          [full]="false"
          [disabled]="rightButtonData().disabled"
          [aspectSquare]="true"
        ></app-button-atom>
      </ng-template>
      <ng-template #content>
        <div class="max-width-full flex flex-row">
          @if (displayRedeemableGifts) {
            @for (asset of redeemableAssets(); track asset) {
              <div class="mr-3 w-40 max-w-40 flex-shrink-0 flex-grow-0">
                <app-kiosk-como-item-atom
                  [asset]="asset"
                  [displayAddButton]="true"
                  [isAssetInCart]="(isAssetInCart$(asset) | async) ?? false"
                  (assetAdd)="onAssetAdd(asset)"
                  (assetRemove)="onAssetRemove(asset)"
                ></app-kiosk-como-item-atom>
              </div>
            }
          }
          @if (displayRedeemablePointShop) {
            @for (asset of redeemablePointShops(); track asset) {
              <div class="mr-3 w-40 max-w-40 flex-shrink-0 flex-grow-0">
                <app-kiosk-como-item-atom
                  [asset]="asset"
                  [isAssetInCart]="(isAssetInCart$(asset) | async) ?? false"
                  (assetAdd)="onAssetAdd(asset)"
                  (assetRemove)="onAssetRemove(asset)"
                ></app-kiosk-como-item-atom>
              </div>
            }
          }
          @if (displayNotRedeemableGifts) {
            @for (asset of noRedeemableAssets(); track asset) {
              <div class="mr-3 w-40 max-w-40 flex-shrink-0 flex-grow-0">
                <app-kiosk-como-item-atom
                  [asset]="asset"
                  [isAssetInCart]="(isAssetInCart$(asset) | async) ?? false"
                  (assetAdd)="onAssetAdd(asset)"
                  (assetRemove)="onAssetRemove(asset)"
                ></app-kiosk-como-item-atom>
              </div>
            }
          }
          @if (displayNotRedeemablePointShop) {
            @for (asset of noRedeemablePointShops(); track asset) {
              <div class="mr-3 w-40 max-w-40 flex-shrink-0 flex-grow-0">
                <app-kiosk-como-item-atom
                  [asset]="asset"
                  [isAssetInCart]="(isAssetInCart$(asset) | async) ?? false"
                  (assetAdd)="onAssetAdd(asset)"
                  (assetRemove)="onAssetRemove(asset)"
                ></app-kiosk-como-item-atom>
              </div>
            }
          }
          @if (displayNotUsablePointShop) {
            @for (asset of pointShops(); track asset) {
              <div class="mr-3 w-40 max-w-40 flex-shrink-0 flex-grow-0">
                <app-kiosk-como-item-atom
                  [asset]="asset"
                  (assetAdd)="onAssetAdd(asset)"
                  (assetRemove)="onAssetRemove(asset)"
                ></app-kiosk-como-item-atom>
              </div>
            }
          }
        </div>
      </ng-template>
    </app-kiosk-horizontal-scroll>
  </div>
}
